module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_21-50e7e709f67f89c6b27e1182e338802a.png";